import { render, staticRenderFns } from "./PendingCertificatesList.vue?vue&type=template&id=42d44c23"
import script from "./PendingCertificatesList.vue?vue&type=script&lang=ts"
export * from "./PendingCertificatesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports